import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { TooltipTrigger as d, Tooltip as t } from "./index.js";
function u(i) {
  return c(function(s, o) {
    const { tooltip: e, ...p } = s, n = !(e != null && e.children) || e.isDisabled;
    return /* @__PURE__ */ a(
      d,
      {
        isDisabled: n,
        isOpen: e == null ? void 0 : e.isOpen,
        defaultOpen: e == null ? void 0 : e.defaultOpen,
        onOpenChange: e == null ? void 0 : e.onOpenChange,
        children: [
          /* @__PURE__ */ r(i, { ...p, ref: o }),
          !n && /* @__PURE__ */ r(t, { placement: e.placement, children: e.children })
        ]
      }
    );
  });
}
export {
  u as withTooltip
};
//# sourceMappingURL=withTooltip.js.map
